(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["winter-collection-prelaunch"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-winter-launch]');
    roots.forEach((root) => {
      const launchAt = new Date(root.dataset.launchAt).getTime();
      const prelaunch = root.querySelector('[data-winter-prelaunch]');
      const live = root.querySelector('[data-winter-live]');
      const countdown = root.querySelector('[data-winter-countdown]');
      let timer;
      let liveRefreshPending = false;
      let lastLiveRefresh = 0;
      const refreshLiveProducts = async () => {
        if (liveRefreshPending || live.querySelector('.winter-launch__product')) return;
        const now = Date.now();
        if (now - lastLiveRefresh < 5000) return;
        lastLiveRefresh = now;
        liveRefreshPending = true;
        try {
          const wrapper = root.closest('.shopify-section');
          if (!wrapper) return;
          const url = new URL(window.location.href);
          url.searchParams.set('section_id', wrapper.id.replace('shopify-section-', ''));
          url.searchParams.set('_winter_launch', String(now));
          const response = await fetch(url.toString(), { cache: 'no-store' });
          if (!response.ok) return;
          const rendered = new DOMParser().parseFromString(await response.text(), 'text/html');
          const freshLive = rendered.querySelector('[data-winter-live]');
          if (freshLive && freshLive.querySelector('.winter-launch__product')) {
            live.innerHTML = freshLive.innerHTML;
          }
        } catch (error) {
        } finally {
          liveRefreshPending = false;
        }
      };


      const setValue = (name, value) => {
        const element = root.querySelector(`[data-winter-${name}]`);
        if (element) element.textContent = String(value).padStart(2, '0');
      };

      const update = () => {
        const distance = launchAt - Date.now();
        const launched = distance <= 0;
        prelaunch.hidden = launched;
        live.hidden = !launched;
        if (launched) {
          if (live.querySelector('.winter-launch__product') || Date.now() - launchAt > 600000) {
            if (timer) window.clearInterval(timer);
          } else {
            refreshLiveProducts();
          }
          return;
        }
        setValue('days', Math.floor(distance / 86400000));
        setValue('hours', Math.floor((distance % 86400000) / 3600000));
        setValue('minutes', Math.floor((distance % 3600000) / 60000));
        setValue('seconds', Math.floor((distance % 60000) / 1000));
        if (countdown) countdown.setAttribute('aria-live', 'polite');
      };

      update();
      timer = window.setInterval(update, 1000);

      const success = root.querySelector('[data-winter-success]');
      if (success) success.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
